import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  ArrowLeft,
  Save,
  Building2,
  KeyRound,
  Hash,
} from "lucide-react";
import MainLayout from "../layouts/MainLayout";

const AddEditBackupOutletMaster = ({
  data,
  onClose,
}) => {
  const API_URL = process.env.REACT_APP_API_URL;

  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    id: "",
    outletId: "",
    outletName: "",
    outletKey: "",
    status: true,
  });

  useEffect(() => {
    if (data) {
      setFormData({
        id: data.id || "",
        outletId: data.outletId || "",
        outletName: data.outletName || "",
        outletKey: data.outletKey || "",
        status: data.status ?? true,
      });
    }
  }, [data]);

  const handleChange = (e) => {
    const { name, value, checked, type } =
      e.target;

    setFormData((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
          : value,
    }));
  };

  const handleSave = async () => {
    try {
      if (!formData.outletId) {
        return alert(
          "Please enter Outlet ID"
        );
      }

      if (!formData.outletName) {
        return alert(
          "Please enter Outlet Name"
        );
      }

      if (!formData.outletKey) {
        return alert(
          "Please enter Outlet Key"
        );
      }

      setLoading(true);

      const payload = {
        id: formData.id || "",
        outletId: Number(
          formData.outletId
        ),
        outletName:
          formData.outletName,
        outletKey:
          formData.outletKey,
        status: formData.status,
      };

      await axios.post(
        `${API_URL}/BackupOutlet/Upsert`,
        payload
      );

      alert(
        data
          ? "Outlet Updated Successfully"
          : "Outlet Created Successfully"
      );

      onClose();
    } catch (error) {
      console.log(error);
      alert("Failed to save outlet");
    } finally {
      setLoading(false);
    }
  };

  return (
 <MainLayout>
  <div className="p-3 md:p-6">
    <div className="bg-white rounded-xl shadow-sm border border-slate-200">

      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4 border-b p-4 md:p-6">
        <div>
          <h2 className="text-xl md:text-2xl font-bold text-slate-800">
            {data
              ? "Edit Backup Outlet"
              : "Add Backup Outlet"}
          </h2>

          <p className="text-sm text-slate-500 mt-1">
            Configure outlet backup settings
          </p>
        </div>

        <button
          onClick={onClose}
          className="flex items-center justify-center gap-2 px-4 py-2 bg-slate-200 hover:bg-slate-300 rounded-lg transition"
        >
          <ArrowLeft size={18} />
          Back
        </button>
      </div>

      {/* Form */}
      <div className="p-4 md:p-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">

          {/* Outlet ID */}
          <div>
            <label className="block text-sm font-medium mb-2">
              Outlet ID
            </label>

            <div className="relative">
              <Hash
                size={18}
                className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
              />

              <input
                type="number"
                name="outletId"
                value={formData.outletId}
                onChange={handleChange}
                placeholder="Enter Outlet ID"
                className="w-full pl-10 pr-4 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          {/* Outlet Name */}
          <div>
            <label className="block text-sm font-medium mb-2">
              Outlet Name
            </label>

            <div className="relative">
              <Building2
                size={18}
                className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
              />

              <input
                type="text"
                name="outletName"
                value={formData.outletName}
                onChange={handleChange}
                placeholder="Enter Outlet Name"
                className="w-full pl-10 pr-4 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          {/* Outlet Key */}
          <div>
            <label className="block text-sm font-medium mb-2">
              Outlet Key
            </label>

            <div className="relative">
              <KeyRound
                size={18}
                className="absolute left-3 top-1/2 -translate-y-1/2 text-slate-400"
              />

              <input
                type="text"
                name="outletKey"
                value={formData.outletKey}
                onChange={handleChange}
                placeholder="Enter Outlet Key"
                className="w-full pl-10 pr-4 py-3 border rounded-xl focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          </div>

          {/* Status */}
          <div>
            <label className="block text-sm font-medium mb-2">
              Status
            </label>

            <div className="h-[50px] flex items-center border rounded-xl px-4">
              <input
                type="checkbox"
                name="status"
                checked={formData.status}
                onChange={handleChange}
                className="h-4 w-4 mr-3"
              />

              <span className="text-sm">
                Active Outlet
              </span>
            </div>
          </div>

        </div>

        {/* Buttons */}
        <div className="flex flex-col sm:flex-row gap-3 mt-8">
          <button
            onClick={handleSave}
            disabled={loading}
            className="flex items-center justify-center gap-2 bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-xl transition"
          >
            <Save size={18} />

            {loading
              ? "Saving..."
              : data
              ? "Update Outlet"
              : "Save Outlet"}
          </button>

          <button
            onClick={onClose}
            className="px-6 py-3 bg-slate-200 hover:bg-slate-300 rounded-xl transition"
          >
            Cancel
          </button>
        </div>

      </div>
    </div>
  </div>
</MainLayout>
  );
};

export default AddEditBackupOutletMaster;